import PropTypes from 'prop-types';

export const ANY_CHILD = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node)
]);

export const SEARCH_TYPE = PropTypes.oneOf([
    'address',
    'destination',
    'event',
    'venue',
    'city',
    'airport'
]);



// WEBPACK FOOTER //
// ./frontend/src/js/utils/prop.js